import React, { useEffect, useState } from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import { Col, Row, Typography, Select, Spin } from 'antd'
import 'isomorphic-fetch'
import { HeaderHero, SEO } from './components'

import RepairShopStyle from '../../styles/DirectRepairShop.module.css'

const tabletImage = 'hero/drs/DRS_1024x300-no-copy.jpg'
const desktopImage = 'hero/drs/DRS_1440x300-no-copy.jpg'
const largeScreenImage = 'hero/drs/DRS_1620x300-no-copy.jpg'
const xtraLargeScreenImage = 'hero/drs/DRS_1960x300-no-copy.jpg'
const smallImage = 'hero/drs/DRS_375x188.jpg'
const smallImage390 = 'hero/drs/DRS_390x188.jpg'
const mobileImage = 'hero/drs/DRS_428x188.jpg'
const mobileImage768 = 'hero/drs/DRS_768x300-no-copy.jpg'

const { Title, Text } = Typography
const { Option } = Select

const DirectRepairShop = () => {
  const [selectedState, setSelectedState] = useState('')
  const [selectedCounty, setSelectedCounty] = useState('')
  const [shopsList, setShopsList] = useState(null)
  const [countyList, setCountyList] = useState(null)

  useEffect(() => {
    async function fetchDRSData(selectedCounty, selectedState) {
      const data = JSON.stringify({
        County: selectedCounty,
        State: selectedState
      })
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: data
      }

      const apiResponse = await fetch(
        `${process.env.NEXT_PUBLIC_API_URL}/api/my-account/GetRepairShops`,
        requestOptions
      ).then(async response => await response.json())
      const filteredList = apiResponse.filter(({ State }) => State === selectedState)
      setShopsList(filteredList)
    }
    async function fetchCountyList(selectedState) {
      const data = JSON.stringify({
        County: '',
        State: selectedState
      })
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: data
      }

      const apiResponse = await fetch(
        `${process.env.NEXT_PUBLIC_API_URL}/api/my-account/GetRepairShops`,
        requestOptions
      ).then(async response => await response.json())
      const filteredList = apiResponse.map(({ County }) => County)
      setCountyList([...new Set(filteredList)])
    }
    if (selectedCounty && selectedState) {
      fetchDRSData(selectedCounty, selectedState)
    }
    if (selectedCounty === null && selectedState) {
      fetchCountyList(selectedState)
    }
  }, [selectedCounty, selectedState])

  const findLocation = async (repairShop, e) => {
    const address = `${repairShop.Address}, ${repairShop.City}, ${repairShop.State}, ${repairShop.Zip}, USA`
    const newWindow = window.open(`http://maps.google.com/?q=${address}`, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  const handleStateChange = key => {
    setSelectedState(key)
    setSelectedCounty(null)
    setShopsList(null)
  }

  const handleCountyChange = key => {
    setSelectedCounty(key)
    setShopsList(null)
  }

  const antIcon = <LoadingOutlined spin style={{ fontSize: 24 }} />

  return (
    <>
      <SEO
        description="CURE has a select group of Direct Repair Shops in your area with the highest standards of quality, workmanship, and customer service."
        title="Direct Repair Shops | CURE Auto Insurance"
        url="/find-repair-shops"
      />
      <Col lg={{ span: 0 }} md={{ span: 0 }} sm={{ span: 24 }} xl={{ span: 0 }} xs={{ span: 24 }}>
        <HeaderHero
          desktopImage={desktopImage}
          largeScreenImage={largeScreenImage}
          mobileImage={mobileImage}
          mobileImage768={mobileImage768}
          smallImage={smallImage}
          smallImage390={smallImage390}
          tabletImage={tabletImage}
          title="DIRECT REPAIR SHOPS"
          xtraLargeScreenImage={xtraLargeScreenImage}
        />
      </Col>
      <Col lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 0 }} xl={{ span: 24 }} xs={{ span: 0 }}>
        <HeaderHero
          desktopImage={desktopImage}
          largeScreenImage={largeScreenImage}
          mobileImage={mobileImage}
          smallImage={smallImage}
          tabletImage={tabletImage}
          title="DIRECT REPAIR SHOPS"
          xtraLargeScreenImage={xtraLargeScreenImage}
        />
      </Col>
      <Row className={`${RepairShopStyle["repair-shop-container"]} page-text-margin`}>
        <Row className={`${RepairShopStyle["margin-bottom-12"]}`}>
          <Text className={`${RepairShopStyle["sub-text"]}`}>
            For your convenience, CURE has a select group of Direct Repair Shops in your area with the highest standards
            of quality, workmanship and customer service. You may choose any auto body shop or a CURE Direct Repair Shop
            for your repairs.
          </Text>
        </Row>
        <Row className={`${RepairShopStyle["margin-bottom-12"]} ${RepairShopStyle["width-100"]}`}>
          <Title className={`${RepairShopStyle["sub-text-bold"]}`} level={4}>
            Find a Direct Repair Shop:
          </Title>
        </Row>
        <Row className={`${RepairShopStyle["margin-bottom-24"]} ${RepairShopStyle["mobile-bottom-0"]}`}>
          <Select onChange={handleStateChange} placeholder="Select a state" value={selectedState || undefined}>
            <Option value="MI">Michigan</Option>
            <Option value="NJ">New Jersey</Option>
            <Option value="PA">Pennsylvania</Option>
          </Select>
          {selectedState && (
            <Select
              className={`${RepairShopStyle["mobile-bottom-0"]}`}
              onChange={handleCountyChange}
              placeholder="Select a county"
              value={selectedCounty}
            >
              {countyList &&
                countyList.map(county => (
                  <Option key={county} value={county}>
                    {county}
                  </Option>
                ))}
            </Select>
          )}
          {selectedState && selectedCounty && (
            <Text className={`${RepairShopStyle["sub-text"]} ${["margin-top-12"]}`}>
              {shopsList &&
                shopsList.length === 0 &&
                'Contact your CURE claims representative to discuss repair options.'}
            </Text>
          )}
        </Row>
        {selectedCounty && (
          <Row className={`${RepairShopStyle["margin-bottom-12"]} ${RepairShopStyle["width-100"]} ${RepairShopStyle["mobile-top-12"]}`}>
            <Title className={`${RepairShopStyle["sub-text-bold"]}`} level={4} />
            <Col span={24}>
              <Row>
                {shopsList ? (
                  shopsList.map((result, index) => {
                    return (
                      <Col key={index} className={`${RepairShopStyle["repair-shop-results-box"]}`}>
                        <Row>
                          <Text className={`${RepairShopStyle["repair-shop-name"]}`}>
                            <a onClick={e => findLocation(result, e)}>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: result.ShopName
                                }}
                              />
                            </a>
                          </Text>
                          <Text className={`${RepairShopStyle["repair-shop-subtext"]}`}>{result.Address}</Text>
                          <Text className={`${RepairShopStyle["repair-shop-subtext"]}`}>{`${result.City}, ${result.State} ${result.Zip}`}</Text>
                          <Text className={`${RepairShopStyle["repair-shop-subtext"]} ${RepairShopStyle["desktop"]}`}>{result.Phone}</Text>
                          <Text className={`${RepairShopStyle["repair-shop-subtext"]} ${RepairShopStyle["mobile"]}`}>
                            <a href={`tel:+1${result.Phone}`}>{result.Phone}</a>
                          </Text>
                        </Row>
                      </Col>
                    )
                  })
                ) : (
                  <Spin indicator={antIcon} />
                )}
              </Row>
            </Col>
          </Row>
        )}
      </Row>
    </>
  )
}

DirectRepairShop.propTypes = {}

export default DirectRepairShop
